require('es6-promise').polyfill(); //IE11

import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';

Vue.use(Vuex);

import Env from '@lib/Env';

import { IRootState } from '@types';

import Menu from './MenuStore';
import Auth from './AuthStore';
import Popup from './PopupStore';
import Actors from './ActorStore';
import WinList from './StatsStore';
import Contracts from './ContractStore';
import Events from './EventsStore';
import Portfolio from './PortfolioStore';
import AClient from './Admin/ClientStore';
import AProject from './Admin/ProjectStore';
import AActor from './Admin/ActorStore';
import ACharacter from './Admin/CharacterStore';
import AOrder from './Admin/OrderStore';
import ALang from './Admin/LangStore';
import AStatistics from './Admin/StatisticsStore';
import ADashboard from './Admin/AdminStore';
import Acontract from './Admin/ContractStore';
import Video from './VideoStore';

const store: StoreOptions<IRootState> = {
    state: {
        isSmallScreen: false,
        isSmallerScreen: false,
        isSmallScreenValue: 800,
        isSmallerScreenValue: 680,
    },

    getters: {
        getIsSmallScreen: (state): boolean => state.isSmallScreen,
        getIsSmallerScreen: (state): boolean => state.isSmallerScreen,
    },

    mutations: {
        setScreenHeight: (state, height: number) => {
            state.isSmallScreen = height < state.isSmallScreenValue;
            state.isSmallerScreen = height < state.isSmallerScreenValue;
        },
    },

    actions: {},

    modules: {
        Auth,
        Popup,
        Menu,
        Actors,
        WinList,
        Contracts,
        Portfolio,
        AClient,
        AProject,
        AActor,
        ACharacter,
        AOrder,
        ALang,
        Video,
        AStatistics,
        ADashboard,
        Acontract,
        Events,
    },
};

export default new Vuex.Store<IRootState>(store);
